// Product gallery: main image Swiper + clickable thumbnail rail.
// No jQuery dependency — Swiper itself doesn't need it, only OLD/product-slider.js's
// wrapper did.
;(function () {
  function initGallery(root) {
    if (root.dataset.galleryInit) return
    if (typeof Swiper === 'undefined') return

    var swiperEl = root.querySelector('.product-gallery__swiper')
    if (!swiperEl) return
    root.dataset.galleryInit = 'true'

    var thumbs = root.querySelectorAll('.product-gallery__thumb')
    var prev = root.querySelector('.product-gallery__arrow--prev')
    var next = root.querySelector('.product-gallery__arrow--next')

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 400,
      a11y: true,
      initialSlide: parseInt(swiperEl.dataset.initialSlide, 10) || 0,
      navigation: prev && next ? { prevEl: prev, nextEl: next } : false,
      on: {
        slideChange: function (instance) {
          thumbs.forEach(function (thumb, i) {
            var active = i === instance.activeIndex
            thumb.classList.toggle('is-active', active)
            thumb.setAttribute('aria-selected', active)
            if (active) {
              thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' })
            }
          })
        },
      },
    })

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        swiper.slideTo(parseInt(thumb.dataset.index, 10))
      })
    })
  }

  function initAll() {
    document.querySelectorAll('.product-gallery').forEach(initGallery)
  }

  document.addEventListener('DOMContentLoaded', initAll)
  document.addEventListener('shopify:section:load', initAll)
})()